module.exports = __webpack_public_path__ + "img/erbel.b62281e8.jpg";